import React, { useState } from "react";
import { TextField } from "@mui/material";

import { FormFieldContainer } from "components/ui/FormField";
import {
    FormContainer,
    inputStyles,
} from "components/ui/FormField/FormFieldContainer";
import { LoadingButton } from "@mui/lab";
import Page from "components/ui/Page/Page";

const EligibilityForm = ({ formData, onChange, onSubmit, isSubmitting }) => {
    const [errors, setErrors] = useState({});

    const validateZipCode = (value) => {
        const regex = /^[a-zA-Z0-9\s-]{3,10}$/;
        if (value && !regex.test(value)) {
            return "Please enter a valid zip code";
        }
        return "";
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        onChange("moreInfo", name, value);
        if (name === "zipCode") {
            setErrors((prev) => ({ ...prev, zipCode: validateZipCode(value) }));
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit();
    };

    return (
        <Page
            heading="Last bit of Information"
            subHeading="We need a bit more information from you to confirm your eligibility!
                Please enter your zip code below to confirm it's you."
        >
            <FormContainer>
                <FormFieldContainer
                    heading="Zip Code"
                    required
                    errorMessage={errors.zipCode}
                    fields={[
                        <TextField
                            fullWidth
                            name="zipCode"
                            value={formData.zipCode}
                            onChange={handleChange}
                            sx={inputStyles()}
                        />,
                    ]}
                />
                <LoadingButton
                    onClick={handleSubmit}
                    variant="outlined"
                    loading={isSubmitting}
                    disabled={!formData.zipCode || !!errors.zipCode}
                    sx={{
                        width: "100%",
                        maxWidth: "594px",
                        alignSelf: "center",
                    }}
                >
                    Submit
                </LoadingButton>
            </FormContainer>
        </Page>
    );
};

export default EligibilityForm;
